import { Component, DestroyRef, effect, inject, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup, MatTab } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { forkJoin, of, switchMap } from 'rxjs';
import { Extension } from 'src/app/models/centrex/extension';
import { ExtensionService } from 'src/app/services/centrex/extension.service';
import { ExtensionDisplayPipe } from '../../../pipes/extension-display.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalRulesComponent } from '../../globalRules/global-rules/global-rules.component';
import { ExtensionRulesComponent } from '../extension-rules/extension-rules.component';
import { ExtensionFormComponent } from '../extension-form/extension-form.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { InstanceService } from 'src/app/services/centrex/instance.service';
import { Instance } from 'src/app/models/centrex/instance';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ExtensionTypes } from 'src/app/models/centrex/enums/extension-types';

@Component({
    selector: 'app-extension',
    templateUrl: './extension.component.html',
    styleUrls: ['./extension.component.scss'],
    imports: [FaIconComponent, MatTabGroup, MatTab, ExtensionFormComponent, ExtensionRulesComponent, GlobalRulesComponent, TranslateModule, ExtensionDisplayPipe]
})
export class ExtensionComponent implements OnInit {
    private readonly instanceService = inject(InstanceService);
    private readonly router = inject(Router);
    private destroyRef = inject(DestroyRef);

    // Icône
    public faAngleRight = faAngleRight;

    extensionInformations: Extension = null;
    extensionsList: Extension[] = null;
    public indexTab: number = 0;
    extensionTypes = ExtensionTypes;

    @ViewChild('extensionTab', { static: true }) extensionTab: MatTabGroup;

    private previousInstance: Instance;

    constructor(private route: ActivatedRoute, private extensionService: ExtensionService) {
        // Récupère, si présent, l'onglet à sélectionner
        let tab = this.router.getCurrentNavigation()?.extras?.state?.tab;
        if (tab && tab === 'rule') {
            this.indexTab = 1;
        }

        this.previousInstance = this.instanceService.instance();

        effect(() => {
            if (this.instanceService.instance() && this.previousInstance.id !== this.instanceService.instance().id) {
                this.router.navigate(['/extensions']);
            }
        });
    }

    ngOnInit(): void {
        let extensionId: string;

        // Récupère l'identifiant du site
        // this.route.queryParams
        //     .pipe(
        //         switchMap((params) => {
        //             extensionId = params['id'];

        //             if (extensionId) {
        //                 return this.extensionService.getExtension(extensionId);
        //             } else {
        //                 return of(new Extension());
        //             }
        //         }),
        //         takeUntilDestroyed(this.destroyRef)
        //     )
        //     .subscribe((extension) => {
        //         this.extensionInformations = extension;
        //         this.extensionTab.selectedIndex = this.indexTab;
        //     });

        this.route.queryParams
            .pipe(
                switchMap((params) => {
                    extensionId = params['id'];

                    if (extensionId) {
                        return forkJoin([this.extensionService.getExtension(extensionId), this.extensionService.getExtensions()]);
                    } else {
                        return forkJoin([of(new Extension()), this.extensionService.getExtensions()]);
                    }
                })
            )
            .subscribe({
                next: ([extension, extensionsList]) => {
                    this.extensionInformations = extension;
                    this.extensionTab.selectedIndex = this.indexTab;
                    this.extensionsList = extensionsList;
                },
            });
    }
}
